export const ERROR_MAP = {
    required: 'This field is required',
    minlength: 'Minimum number of characters is not met',
    email: 'Email is invalid',
};
